import types from "../../actions/types"

export default function remove(state, action) {
  switch (action.type) {
    case types.remove:
      return state
    case types.removeSuccess:
      return {
        ...state,
        data: null,
      }
    case types.removeError:
      return {
        ...state,
        error: action.error,
      }
    case types.removeCancel:
      return state
    default:
      return state
  }
}
